import { LoginService } from './../../shared-modules/login/login.service';
import { TylerMatTableDataSource } from './../../shared-components/angular-material/extended.class';
import { System } from './../../shared-components/System';
import { StudentService } from './../../shared-components/student/student.service';
import { Component, OnInit, ViewChild, OnDestroy, ChangeDetectorRef, EventEmitter } from '@angular/core';
import { TeamsService } from './teams.service';
import { Team } from './team.model';
import { Subscription } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { YearService } from '../../shared-components/year/year.service';

@Component({
    selector: 'teams',
    templateUrl: './teams.component.html',
    styleUrls: [
        './teams.component.css'
    ]
})
export class TeamsComponent implements OnInit, OnDestroy {

    // Properties
    private _sort: MatSort;
    private _includeInactiveTeams = false;
    teams: Team[];
    subscriptions: Subscription[] = [];
    tableData = new TylerMatTableDataSource();
    showStudentTeams = false;
    hiddenTeamColumns = ['Name', 'Details', 'Entry', 'Staff', 'Comment'];
    shownTeamColumns = ['Name', 'Staff', 'Entry', 'Exit'];
    selectedRow: Team;
    junkDate = System.junkDate;
    clearFilterEvent = new EventEmitter<any>();
    pageTitle: string;

    // Class Functions
    constructor(
        private teamService: TeamsService,
        private studentService: StudentService,
        private loginService: LoginService,
        private yearService: YearService,
        public changeDetector: ChangeDetectorRef
    ) { }

    get sort(): MatSort {
        return this._sort;
    }

    @ViewChild(MatSort) set sort(value: MatSort) {
        this._sort = value;
        if (this.tableData) {
            this.tableData.sort = this._sort;
        }
    }

    get includeInactiveTeams(): boolean {
        return this._includeInactiveTeams;
    }

    set includeInactiveTeams(value: boolean) {
        this._includeInactiveTeams = value;
        if (this.tableData) {
            if (value) {
                this.tableData.data = this.teams;
            } else {
                const filteredTeams = this.teams.filter(team => team.Active);
                this.tableData.data = filteredTeams;
            }
        }
    }

    // Event Functions
    ngOnInit() {
        // POST: initializes the data and performs the initial subscriptions
        this.pageTitle = 'Activities';
        this.showStudentTeams = this.loginService.LoginSettings.ParentPortalShowStudentTeams;
        this.subscriptions.push(
            this.studentService.selectedStudentStream$.subscribe(() => {
                this.teams = undefined;
                this.getTeams();
            }),
            this.yearService.observableStudent360YearStream$.subscribe(student360Year => {
                this.getTeams();
            })
        );
    }

    ngOnDestroy() {
        // POST: ends all subscriptions
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
    }

    // Methods
    getTeams() {
        // POST: obtains the teams from the server and organizes the table data
        this.subscriptions.push(
            this.teamService.getStudentTeams().subscribe(teams => {
                this.teams = teams;

                // Performing conversions for type safety
                for (let i = 0; i < this.teams.length; i++) {
                    this.teams[i] = System.convert<Team>(this.teams[i], new Team());
                }

                // Setting the table data
                if (this.includeInactiveTeams) {
                    this.tableData.data = this.teams;
                } else {
                    const filteredTeams = this.teams.filter(team => team.Active);
                    this.tableData.data = filteredTeams;
                }
                if (this.sort) {
                    this.tableData.sort = this.sort;
                }
            })
        );
    }
}